export const values = {
  contents: {
    prefix: 'https://us.wink.co.kr/pc/renewalV3/company/content',
    imgCount: 5,
    modifiedInfoList: [
      {
        modifiedDate: '230621',
        modifiedIndexList: [5],
      },
      {
        modifiedDate: '211201',
        modifiedIndexList: [5],
      },
    ],
    backgroundColors: ['#fff', '#e2f5fa', '#f6f6f6', '#fff', '#fde9f1'],
    sizes: [
      { width: 1918, height: 83 },
      { width: 1918, height: 898 },
      { width: 1918, height: 1454 },
      { width: 1918, height: 1413 },
      { width: 1918, height: 6299 },
    ],
  },
};

export const ROOT_MARGIN = 500;
